import { FormSectionLangFieldMap } from '@/types'
import { FieldType, SupportedLanguage } from '@/enum'
import { COMPLEXION_OPTIONS } from '../data/ComplexionOptions'
import { HEIGHT_OPTIONS } from '../data/HeightOptions'
import { BLOODGROUP_OPTIONS } from '../data/BloodGroupOptions'
import { RASHI_OPTIONS } from '../data/RashiOptions'
import { INCOME_OPTIONS } from '../data/IncomeOptions'
import { format } from 'date-fns'
import { NAKSHATRA_OPTIONS } from '../data/NakshatraOptions'
import { MARITALSTATUS_OPTIONS } from '../data/MaritalStatusOptions'
import { HOBBIES_OPTIONS } from '../data/HobbiesOptions'
import { LANGUAGES_OPTIONS } from '../data/LanguagesOptions'
import { KULDEVTAS_OPTIONS } from './KuldevtasOptions'
import { GAN_OPTIONS } from './GanOptions'
import { NADI_OPTIONS } from './NadiOptions'
import { MANGALIK_OPTIONS } from './MangalikOptions'

export const PERSONAL_DETAILS_DATA: FormSectionLangFieldMap = {
  [SupportedLanguage.English]: [
    {
      id: 'e45e3032-8666-4928-8459-8a327779bfd7',
      label: 'Name',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'Ankit Verma',
      identifier: 'name',
    },
    {
      id: '814de063-014c-4739-8e13-25fef67927e6',
      label: 'Date Of Birth',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '03404315-c088-4d15-9319-bd743f8a0033',
      label: 'Time Of Birth',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: '3023852e-b926-4622-a78a-34b3b308f661',
      label: 'Place Of Birth',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'Mumbai',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: 'bf8052d9-79b7-4d7e-8eca-e3e792cafd37',
      label: 'Marital Status',
      value: 'Never Married',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.English],
      identifier: 'maritalstatus',
    },
    {
      id: '16f50487-0e60-40e4-bc57-f229b530c91b',
      label: 'Complexion',
      value: 'Fair',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.English],
      identifier: 'complexion',
    },
    {
      id: 'f6b1781e-2958-45d3-bad6-427217f13cb3',
      label: 'Height',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: 'fbd36966-ff97-481f-ac86-3552c4fddd95',
      label: 'Blood Group',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.English],
      identifier: 'bloodgroup',
    },
    {
      id: '409e16ad-183a-4774-9282-ce2d83324e58',
      label: 'Caste',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'Sonar / Sunar',
      identifier: 'caste',
    },
    {
      id: '52d5e530-a030-4456-9cc4-ab28461899e0',
      label: 'Gothra',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'Kashyapa',
      identifier: 'gothra',
    },
    {
      id: 'c6e741b5-964c-432b-89a8-368a73174d7e',
      label: 'Mool',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'Chatrapuri',
      identifier: 'mool',
    },
    {
      id: '017b0fe8-1002-41a2-bc0c-d399a2ab633e',
      label: 'Rashi',
      value: 'Aries (Mesh)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.English],
      identifier: 'rashi',
    },
    {
      id: '297d2275-20e6-40eb-9e03-8122147fb094',
      label: 'Nakshatra',
      value: 'Ashwini',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'Ashwini',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.English],
      identifier: 'nakshatra',
    },
    {
      id: 'b71ee1a3-6240-4043-8039-1e974c630f2c',
      label: 'Hobbies',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'Choose or type and press Enter',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.English],
    },
    {
      id: 'ff529ae5-ba1a-462c-90a6-3d6a878128ba',
      label: 'Education',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'B.Com. (Bachelor of Commerce)',
      identifier: 'education',
    },
    {
      id: '4a2a5bf8-f016-4cb5-bfbb-5bf17a28b067',
      label: 'Occupation',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'Human Resources (HR)',
      identifier: 'occupation',
    },
    {
      id: 'c9aaf137-f203-4de0-89d7-72235621d684',
      label: 'Work',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ICICI Bank, Mumbai',
      identifier: 'work',
    },
    {
      id: '89d7df8a-5c02-41a9-ae4c-3a8eda816d74',
      label: 'Income (Anually)',
      value: '₹ 5 - 7.5 Lakh',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.English],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Hindi]: [
    {
      id: 'b58393c3-91f9-4fd1-b990-e990b8254149',
      label: 'नाम',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'अंकित वर्मा',
      identifier: 'name',
    },
    {
      id: '82e15556-37f4-4fcc-8e39-ed4cbbf2fd7b',
      label: 'जन्म तिथि',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '145afcf1-9fa4-487a-ba18-969e49608118',
      label: 'जन्म का समय',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: '514afd01-db4b-4e36-bff0-d886b3bd8376',
      label: 'जन्म स्थान',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'मुंबई',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: '64d80c95-5f1c-46c7-9889-1ba9d1b050b0',
      label: 'वैवाहिक स्थिति',
      value: 'अविवाहित',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Hindi],
      identifier: 'maritalstatus',
    },
    {
      id: 'bb0b95fc-0480-43f3-a111-25833427fbe6',
      label: 'रंग',
      value: 'गोरा',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Hindi],
      identifier: 'complexion',
    },
    {
      id: 'fd115bb2-bd4e-4216-a1b9-9ac74769d7fc',
      label: 'कद',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: '9f4b522b-a726-4cb0-a20c-ecdabdf5d552',
      label: 'रक्त समूह',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Hindi],
      identifier: 'bloodgroup',
    },
    {
      id: '6f8c0251-a0b0-49bd-8899-d24e6c60781e',
      label: 'जाति',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'सोनार / सुनार',
      identifier: 'caste',
    },
    {
      id: '043ef04e-0a46-402b-8802-9c5a75441e93',
      label: 'गोत्र',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'कश्यप',
      identifier: 'gothra',
    },
    {
      id: 'e935b5a6-88c9-467c-aa28-3cc7d24842b9',
      label: 'मूल',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'छत्रपुरी',
      identifier: 'mool',
    },
    {
      id: '7c7b29a0-2f9f-40b7-ae26-174901491c2d',
      label: 'राशि',
      value: 'मेष (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Hindi],
      identifier: 'rashi',
    },
    {
      id: '093e7e18-d74c-4ed9-8b34-8a339a554d0f',
      label: 'नक्षत्र',
      value: 'अश्विनी',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'अश्विनी',
      identifier: 'nakshatra',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Hindi],
    },
    {
      id: '761586cb-45a6-4ee4-8dd2-b47abc77d4fb',
      label: 'शौक',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'चुनें या टाइप करें और एंटर दबाएं',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Hindi],
    },
    {
      id: '988cb73a-73ee-47f7-83aa-a6771d9c2477',
      label: 'शिक्षा',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'बी.कॉम. (वाणिज्य स्नातक)',
      identifier: 'education',
    },
    {
      id: '8ca07ffb-ed07-4317-80a5-2dde0d6b347e',
      label: 'पेशा',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'मानव संसाधन (एचआर)',
      identifier: 'occupation',
    },
    {
      id: 'b8f81074-d330-4998-96a4-853d70149bb3',
      label: 'व्यवसाय',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ICICI बैंक, मुंबई',
      identifier: 'work',
    },
    {
      id: 'f968d6c5-903c-4356-a87f-ea4741cbc7a8',
      label: 'आय (वार्षिक)',
      value: '₹ 5 - 7.5 लाख',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Hindi],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Marathi]: [
    {
      id: '76787e80-ffcd-4eb6-8149-46550fd391d3',
      label: 'नाव',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'अंकित वर्मा',
      identifier: 'name',
    },
    {
      id: '5097496b-6841-4f1e-9dc9-c054d3446153',
      label: 'जन्मतारीख',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '57c0b482-6b30-496d-9c65-af3bcd91afcb',
      label: 'जन्मवेळ',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: 'b317be22-fa8d-41ba-8975-3dc276e01e98',
      label: 'जन्मस्थान',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'मुंबई',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: '0582db21-6119-4817-b76b-7d06b374790a',
      label: 'वैवाहिक स्थिती',
      value: 'अविवाहित',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Marathi],
      identifier: 'maritalstatus',
    },
    {
      id: 'a8d74047-a966-4272-bc0c-2ce984a5ade0',
      label: 'वर्ण',
      value: 'गोरा',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Marathi],
      identifier: 'complexion',
    },
    {
      id: '6cf818ee-b64f-499f-bdfc-4d4c81fe69d6',
      label: 'उंची',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: 'c79dcbd2-c80f-4198-bf2c-14061a8a5c5a',
      label: 'रक्तगट',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Marathi],
      identifier: 'bloodgroup',
    },
    {
      id: '2f8d8f46-dc41-4532-8d0a-27ffa432276c',
      label: 'जात',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'सोनार / सुनार',
      identifier: 'caste',
    },
    {
      id: '7ab33647-c6a8-4a87-b157-2bf1dfcc1874',
      label: 'गोत्र',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'कश्यप',
      identifier: 'gothra',
    },
    {
      id: '200ae439-a5ed-4611-a9d8-26aa23318931',
      label: 'कुलदैवत',
      value: '',
      type: FieldType.AUTOCOMPLETE_DROPDOWN,
      isHidden: false,
      isDefault: true,
      placeholder: 'खंडोबा',
      identifier: 'kuldevat',
      options: KULDEVTAS_OPTIONS[SupportedLanguage.Marathi],
    },
    {
      id: 'd1ee4caa-acb9-415a-a37d-e95a9e823e46',
      label: 'गण',
      value: '',
      type: FieldType.AUTOCOMPLETE_DROPDOWN,
      isHidden: false,
      isDefault: true,
      placeholder: 'मनुष्य',
      identifier: 'gan',
      options: GAN_OPTIONS[SupportedLanguage.Marathi],
    },
    {
      id: '5d3f282e-5071-484e-9f81-9597b8edaf5e',
      label: 'नाडी',
      value: '',
      type: FieldType.AUTOCOMPLETE_DROPDOWN,
      isHidden: false,
      isDefault: true,
      placeholder: 'आद्य',
      identifier: 'nadi',
      options: NADI_OPTIONS[SupportedLanguage.Marathi],
    },
    {
      id: '7637c950-d0fd-4b6e-a6cc-75fcc28c141c',
      label: 'मांगलिक',
      value: '',
      type: FieldType.AUTOCOMPLETE_DROPDOWN,
      isHidden: false,
      isDefault: true,
      placeholder: 'नाही',
      identifier: 'mangalik',
      options: MANGALIK_OPTIONS[SupportedLanguage.Marathi],
    },
    {
      id: '7a95c282-7cce-4c4b-95f5-33a4a36fbcfb',
      label: 'मुळ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'छत्रपुरी',
      identifier: 'mool',
    },
    {
      id: 'be2e69bb-a547-4b35-a593-cd13b5872c0a',
      label: 'राशी',
      value: 'मेष (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Marathi],
      identifier: 'rashi',
    },
    {
      id: 'eed6cd1a-6643-4101-b91d-31e654709a92',
      label: 'नक्षत्र',
      value: 'अश्विनी',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'अश्विनी',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Marathi],
      identifier: 'nakshatra',
    },
    {
      id: 'a4c68482-8457-4b86-a2d0-c5fb1d1b89fb',
      label: 'छंद',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'निवडा किंवा टाइप करा आणि एंटर दाबा',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Marathi],
    },
    {
      id: 'ef44a1a7-9506-4f1e-8678-c4716bd3622f',
      label: 'शिक्षण',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'बी.कॉम. (वाणिज्य पदवी)',
      identifier: 'education',
    },
    {
      id: '8d414235-9e46-49b6-b307-b07646d5abde',
      label: 'नोकरी/व्यवसाय',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'मानव संसाधन (HR)',
      identifier: 'occupation',
    },
    {
      id: '6a3f02af-6e38-47ae-b891-984b2bd6fb8e',
      label: 'काम',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ICICI बँक, मुंबई',
      identifier: 'work',
    },
    {
      id: '3377d4b1-0c00-436f-b90b-221ce93dd92a',
      label: 'वेतन / उत्पन्न (वार्षिक)',
      value: '₹ ५ - ७.५ लाख',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Marathi],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Gujarati]: [
    {
      id: '33d1cfca-64db-48e1-87aa-ff6b53d91036',
      label: 'નામ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'અંકિત વર્મા',
      identifier: 'name',
    },
    {
      id: '8ce9aa98-3e17-4eb8-9af1-5550bec76a43',
      label: 'જન્મ તારીખ',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '4cc318f7-228b-4117-aa21-e4c85ef2830b',
      label: 'જન્મ સમય',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: 'e370716a-329f-44b6-9ab3-408c3c43cacb',
      label: 'જન્મ સ્થળ',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'મુંબઈ',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: '1bcd90ce-5cf9-4418-9176-8cb50299116b',
      label: 'વૈવાહિક સ્થિતિ',
      value: 'ક્યારેય લગ્ન નથી કર્યા',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Gujarati],
      identifier: 'maritalstatus',
    },
    {
      id: '8ff395d8-8918-49d0-bacb-f8d903cfc090',
      label: 'રંગ',
      value: 'ગોરું',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Gujarati],
      identifier: 'complexion',
    },
    {
      id: '3281de1c-b89d-4820-b8e1-757601736e49',
      label: 'ઊંચાઈ',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: '470cd909-30ed-4ac4-b531-f4a62c0dbc2c',
      label: 'લોહીનું જૂથ',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Gujarati],
      identifier: 'bloodgroup',
    },
    {
      id: '68c506cc-f590-4b69-8446-3d29b994f860',
      label: 'જાતિ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'સોનાર / સુનાર',
      identifier: 'caste',
    },
    {
      id: 'ddf3c8ad-6bad-4294-a25e-95e953534e8b',
      label: 'ગોત્ર',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'કશ્યપ',
      identifier: 'gothra',
    },
    {
      id: '6d8a7eb4-b034-4229-af1e-18df28e50dd9',
      label: 'મૂળ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'ચત્રપુરી',
      identifier: 'mool',
    },
    {
      id: '557e39d8-4a61-4af0-ba7a-3de6c444368e',
      label: 'રાશિ',
      value: 'મેષ (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Gujarati],
      identifier: 'rashi',
    },
    {
      id: 'c1df8e9c-b551-4f4e-b2fd-e3207ce1f5ef',
      label: 'નક્ષત્ર',
      value: 'અશ્વિની',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'અશ્વિની',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Gujarati],
      identifier: 'nakshatra',
    },
    {
      id: 'a61c3736-4976-46ca-931e-3067c16235b3',
      label: 'શોખ',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'પસંદ કરો અથવા ટાઇપ કરો અને એન્ટર દબાવો',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Gujarati],
    },
    {
      id: '70d48d51-7d4b-4ad2-a1ee-a28adcb6ac27',
      label: 'શિક્ષણ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'બી.કોમ. (બેચલર ઓફ કોમર્સ)',
      identifier: 'education',
    },
    {
      id: '0ba7ce0c-0ed9-4cc4-bd18-ac51e3e6d92e',
      label: 'વ્યવસાય',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'માનવ સંસાધન (HR)',
      identifier: 'occupation',
    },
    {
      id: '50e1c2fa-de66-4a5e-93ef-cc245a991ba2',
      label: 'કામ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ICICI બેંક, મુંબઈ',
      identifier: 'work',
    },
    {
      id: 'ceb2fa49-40af-40d5-ae37-87ce53cbe68e',
      label: 'આવક (વાર્ષિક)',
      value: '₹ 5 - 7.5 લાખ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Gujarati],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Bengali]: [
    {
      id: 'd271ce3c-3e1e-4c01-85c3-fbbef969303c',
      label: 'নাম',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'অঙ্কিত ভার্মা',
      identifier: 'name',
    },
    {
      id: '13e98994-350c-4c1a-b52e-5fe45bb4e206',
      label: 'জন্ম তারিখ',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '4021831d-1557-409d-a40d-8201c1ee4dfd',
      label: 'জন্মসময়',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: 'bcfd4d8e-6203-49fa-b179-89b272133054',
      label: 'জন্মস্থান',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'মুম্বাই',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: '551060e8-8494-4306-8925-284e3676054b',
      label: 'বৈবাহিক অবস্থা',
      value: 'কখনো বিয়ে হয়নি',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Bengali],
      identifier: 'maritalstatus',
    },
    {
      id: '09b7fda4-e9aa-4c54-b9c5-9cba0bfdbce5',
      label: 'বর্ণ',
      value: 'ফর্সা',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Bengali],
      identifier: 'complexion',
    },
    {
      id: '6e0c3713-68df-48e9-90f5-07a325c50f63',
      label: 'উচ্চতা',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: '9d338453-776b-4796-bf24-cc650ac9180c',
      label: 'রক্তের গ্রুপ',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Bengali],
      identifier: 'bloodgroup',
    },
    {
      id: '881555de-c8d0-4f53-8f4b-f59b392d02fd',
      label: 'জাতি',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'সোনার / সুনার',
      identifier: 'caste',
    },
    {
      id: '784fc903-2c60-4a04-be44-9aa71c1fa541',
      label: 'গোত্র',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'কশ্যপ',
      identifier: 'gothra',
    },
    {
      id: 'a71d0ae4-8e24-4733-928e-40218569fce6',
      label: 'মূল',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'চাত্রাপুরি',
      identifier: 'mool',
    },
    {
      id: '998b5b1a-7115-4d76-ac1e-c234e9172c7f',
      label: 'রাশি',
      value: 'মেষ (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Bengali],
      identifier: 'rashi',
    },
    {
      id: '29824ebf-eef3-48a7-84b2-2c41851eaf5b',
      label: 'নক্ষত্র',
      value: 'অশ্বিনী',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'অশ্বিনী',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Bengali],
      identifier: 'nakshatra',
    },
    {
      id: '163bf3b5-92c0-49a8-a2b8-4987a04c3d06',
      label: 'শখ',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'পছন্দ করুন অথবা টাইপ করুন এবং এন্টার প্রেস করুন',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Bengali],
    },
    {
      id: 'e262bd04-0efb-48d7-8087-0c92ce77bcd9',
      label: 'শিক্ষা',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'বি.কম. (ব্যাচেলর অফ কমার্স)',
      identifier: 'education',
    },

    {
      id: '8fde53ff-c526-4c2c-b5bb-1a199917bc65',
      label: 'পেশা',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'হিউম্যান রিসোর্সেস (এইচআর)',
      identifier: 'occupation',
    },
    {
      id: '76c17791-8936-4d8b-82b2-da11fb21d6bf',
      label: 'কর্মস্থল',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'আইসিআইসিআই ব্যাঙ্ক, মুম্বাই',
      identifier: 'work',
    },
    {
      id: '9d106a2f-4787-475b-a762-bd060d51660a',
      label: 'আয় (বার্ষিক)',
      value: '₹ ৫ - ৭.৫ লাখ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Bengali],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Telugu]: [
    {
      id: '28a617f7-1d43-4597-90a2-a8968fe381a2',
      label: 'పేరు',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'అంకిత్ వర్మ',
      identifier: 'name',
    },
    {
      id: 'ff01f84e-3c0b-4c37-a1af-581132c9ba69',
      label: 'జన్మ తేదీ',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: 'c87d5214-e885-4895-88a6-8c75ae9f0b11',
      label: 'జన్మ సమయం',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: 'e2899eca-2f40-4884-8d29-f11466a5cbee',
      label: 'జన్మ స్థలం',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'ముంబై',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: '5133ff3c-502a-48f7-8680-51b913199c2c',
      label: 'వైవాహిక స్థితి',
      value: 'పెళ్లి చేసుకోలేదు',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Telugu],
      identifier: 'maritalstatus',
    },
    {
      id: '762a8034-84ed-4451-a6cb-1d29ce47d6af',
      label: 'చర్మ వర్ణం',
      value: 'తెలుపు',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Telugu],
      identifier: 'complexion',
    },
    {
      id: 'e1fafa36-018e-4059-8a06-5fceb4fdbd1f',
      label: 'ఎత్తు',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: '155c7dff-ab14-433b-897d-f821c6b42fa4',
      label: 'రక్త గ్రూపు',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Telugu],
      identifier: 'bloodgroup',
    },
    {
      id: '35892a2f-9671-4723-8067-f7c1d52213ff',
      label: 'కులం',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'సోనార్ / సునార్',
      identifier: 'caste',
    },
    {
      id: '0b48fe47-3f7a-4a79-a2a0-5d6e90b66375',
      label: 'గోత్రం',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'కశ్యప',
      identifier: 'gothra',
    },
    {
      id: '6b3d8da0-3daa-40ef-9a34-4c08d7d4c3e6',
      label: 'మూల',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'చత్రపురి',
      identifier: 'mool',
    },
    {
      id: '5dd5acb4-fd99-4e6b-9078-41b139dfe736',
      label: 'రాశి',
      value: 'మేష (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Telugu],
      identifier: 'rashi',
    },
    {
      id: 'f159d3e9-995a-41ec-83da-4511a46232de',
      label: 'నక్షత్రం',
      value: 'అశ్విని',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'అశ్విని',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Telugu],
      identifier: 'nakshatra',
    },
    {
      id: 'a47b809b-e6a7-434f-8672-6bb14ea5af4c',
      label: 'అభిరుచులు',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'ఎంచుకోండి లేదా టైప్ చేసి ఎంటర్ నొక్కండి',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Telugu],
    },
    {
      id: '44bbf4c1-45cb-47e2-a0bc-2c17f61c5842',
      label: 'విద్య',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'బి.కాం. (బ్యాచెలర్ ఆఫ్ కామర్స్)',
      identifier: 'education',
    },

    {
      id: 'b390b036-9472-42a0-a636-37673c0c0b99',
      label: 'వృత్తి',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'హ్యూమన్ రిసోర్సెస్ (HR)',
      identifier: 'occupation',
    },
    {
      id: '2e070045-1b8e-491e-8856-e4752f2579c0',
      label: 'పని',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ICICI బ్యాంక్, ముంబై',
      identifier: 'work',
    },
    {
      id: 'ec2e765c-78b1-40c0-a39d-8057761df4f9',
      label: 'ఆదాయం (వార్షికం)',
      value: '₹ 5 - 7.5 లక్షలు',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Telugu],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Kannada]: [
    {
      id: 'cfb5be91-c0b6-41b4-8276-5d7a317b1f21',
      label: 'ಹೆಸರು',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಅಂಕಿತ್ ವರ್ಮಾ',
      identifier: 'name',
    },
    {
      id: '9038b509-a23e-4699-b9cc-f83e568d259a',
      label: 'ಜನ್ಮ ದಿನಾಂಕ',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '3ae17d90-8ae0-409e-9ff7-1db38f3bc772',
      label: 'ಜನ್ಮ ಸಮಯ',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: 'e5b87a7f-d5d2-48e0-9c09-52f766b25621',
      label: 'ಜನ್ಮ ಸ್ಥಳ',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'ಮುಂಬೈ',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: 'e8adb7d0-de49-4220-8b69-2a7d340b8a5a',
      label: 'ವೈವಾಹಿಕ ಸ್ಥಿತಿ',
      value: 'ಮದುವೆಯಾಗದ',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Kannada],
      identifier: 'maritalstatus',
    },
    {
      id: '2d665623-4afc-4b70-bdc1-fa560010f6c4',
      label: 'ಚರ್ಮದ ಬಣ್ಣ',
      value: 'ಮಧ್ಯಮ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Kannada],
      identifier: 'complexion',
    },
    {
      id: '0ed3731b-3a68-446f-a6c8-cd8beb3c4c7f',
      label: 'ಎತ್ತರ',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: 'ac8f8b9e-98c6-40ea-b6dd-094893781e6b',
      label: 'ರಕ್ತದ ಗುಂಪು',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Kannada],
      identifier: 'bloodgroup',
    },
    {
      id: 'f2a96862-2b67-4f61-aec6-d7c3764e4598',
      label: 'ಜಾತಿ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಸೋನಾರ್ / ಸುನಾರ್',
      identifier: 'caste',
    },
    {
      id: '2952c7aa-17f0-44e0-9bda-34086bdc59a5',
      label: 'ಗೋತ್ರ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'ಕಶ್ಯಪ',
      identifier: 'gothra',
    },
    {
      id: '5af46d78-b9c1-45f4-bd7f-5e42335f8f2e',
      label: 'ಮೂಲ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'ಚಾತ್ರಪುರಿ',
      identifier: 'mool',
    },
    {
      id: '60d716ec-017e-4d9f-94e2-03adb0e9c647',
      label: 'ರಾಶಿ',
      value: 'ಮೇಷ (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Kannada],
      identifier: 'rashi',
    },
    {
      id: '16e7e871-c3a4-4392-a7ba-4aec29df95e3',
      label: 'ನಕ್ಷತ್ರ',
      value: 'ಅಶ್ವಿನಿ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'ಅಶ್ವಿನಿ',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Kannada],
      identifier: 'nakshatra',
    },
    {
      id: 'e70069db-fe95-444b-ad6d-1918f3c0e6d1',
      label: 'ಹವ್ಯಾಸಗಳು',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಆಯ್ಕೆಮಾಡಿ ಅಥವಾ ಟೈಪ್ ಮಾಡಿ ಮತ್ತು ಎಂಟರ್ ಒತ್ತಿ',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Kannada],
    },
    {
      id: 'a7541684-eb6a-4775-bdd4-429fadffb149',
      label: 'ಶಿಕ್ಷಣ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಬಿ.ಕಾಂ. (ವಾಣಿಜ್ಯ ಸ್ನಾತಕೋತ್ತರ)',
      identifier: 'education',
    },
    {
      id: '319d80ee-15cf-4173-bc9b-c1175415bb83',
      label: 'ಉದ್ಯೋಗ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಮಾನವ ಸಂಪತ್ತಿನ ನಿರ್ವಹಣೆ (HR)',
      identifier: 'occupation',
    },
    {
      id: 'a6f21583-b3e9-483e-a0ee-97dbef7b99e8',
      label: 'ಕೆಲಸ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ಐಸಿಐಸಿಐ ಬ್ಯಾಂಕ್, ಮುಂಬೈ',
      identifier: 'work',
    },
    {
      id: 'b41991e2-f5e8-4b02-9bcb-618136eb7c1d',
      label: 'ವಾರ್ಷಿಕ ಆದಾಯ',
      value: '₹ 5 - 7.5 ಲಕ್ಷ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Kannada],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Tamil]: [
    {
      id: '19874c2e-debb-401b-ae3c-e308dcf18727',
      label: 'பெயர்', // Name
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'அங்கித் வர்மா',
      identifier: 'name',
    },
    {
      id: 'ff849f5c-4d06-4e38-93f4-7fffff52260c',
      label: 'பிறந்த தேதி', // Date Of Birth
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '0c80e065-b5b8-4d46-bcbf-d83ce407bcc3',
      label: 'பிறந்த நேரம்', // Time Of Birth
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: '2d9508af-8cb3-4d15-bb95-e666a7604b93',
      label: 'பிறந்த இடம்', // Place Of Birth
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'மும்பை',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: '52b6e43d-2a37-42eb-a775-8bad3501491b',
      label: 'திருமண நிலை', // Marital Status
      value: 'திருமணம் செய்யப்படவில்லை',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Tamil],
      identifier: 'maritalstatus',
    },
    {
      id: '508b9cab-c67c-4a30-9bd9-ecd83e848b73',
      label: 'தோல் நிறம்', // Complexion
      value: 'வெளிர் நிறம்',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Tamil],
      identifier: 'complexion',
    },
    {
      id: '587910ce-8ba2-4be8-90f2-a03f48fc2457',
      label: 'உயரம்', // Height
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: '4ec4c19e-d7e8-4c22-a33b-aeab0791b1db',
      label: 'இரத்தக் குழு', // Blood Group
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Tamil],
      identifier: 'bloodgroup',
    },
    {
      id: 'e32a1d95-0c9a-406e-909e-016d89bc08b0',
      label: 'ஜாதி', // Caste
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'சோனார் / சுனர்',
      identifier: 'caste',
    },
    {
      id: '5f0eeeac-9989-40fd-9a12-bde5de16264a',
      label: 'கோத்திரம்', // Gothra
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'காஷ்யபா',
      identifier: 'gothra',
    },
    {
      id: '6b0cd2d7-8962-40cb-b87f-4a06d49a6de4',
      label: 'மூல நக்ஷத்திரம்', // Mool
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'சத்ரபுரி',
      identifier: 'mool',
    },
    {
      id: '20be11aa-8206-4a3c-b07a-cae4f1ec11b0',
      label: 'ராசி', // Rashi
      value: 'மேஷம் (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Tamil],
      identifier: 'rashi',
    },
    {
      id: 'db297273-ac41-4202-abec-d58c700256f7',
      label: 'நட்சத்திரம்', // Nakshatra
      value: 'அசுவினி',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'அசுவினி',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Tamil],
      identifier: 'nakshatra',
    },
    {
      id: '83c14bd9-56bf-4852-ab19-298fb0446378',
      label: 'பொழுதுபோக்குகள்', // Hobbies
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'தேர்வு செய்யுங்கள் அல்லது எழுதுங்கள், பின்னர் Enter அழுத்துங்கள்',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Tamil],
    },
    {
      id: 'd08695b4-df57-4ec2-99fc-11b5274c0164',
      label: 'கல்வி', // Education
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'பி.காம். (வாணிபம் பச்சலர்)',
      identifier: 'education',
    },
    {
      id: '7384fbaa-9aca-491a-8e84-ce0a1c16ca99',
      label: 'தொழில்', // Occupation
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'மனிதவள (HR)',
      identifier: 'occupation',
    },
    {
      id: '330e7f3f-e57e-4601-9711-a1130ba6bf8f',
      label: 'வேலை', // Work
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ஐசிஐசிஐ வங்கி, மும்பை',
      identifier: 'work',
    },
    {
      id: 'e95f6962-5dc0-47ac-bdff-e863ec08373e',
      label: 'வருமானம் (வருடத்திற்கு)', // Income (Annually)
      value: '₹ 5 - 7.5 லட்சம்',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Tamil],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Odia]: [
    {
      id: '6f5a5eb5-6f21-4f5c-b190-c933848e80b9',
      label: 'ନାମ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ଅଙ୍କିତ ବର୍ମା',
      identifier: 'name',
    },
    {
      id: '3d294a13-5cd5-4381-9226-950948fb0ae1',
      label: 'ଜନ୍ମ ତାରିଖ',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: '51c0a6b4-92bc-40c2-949f-4b14bdcd58d8',
      label: 'ଜନ୍ମ ସମୟ',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: 'd4deab85-f9fc-4dcb-831e-8fd0cf509662',
      label: 'ଜନ୍ମ ସ୍ଥାନ',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'ମୁମ୍ବାଇ',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: 'bd74d6ee-0faf-4bf1-aac1-7b3a88f90b50',
      label: 'ବିବାହିତ ସ୍ଥିତି',
      value: 'କଦାପି ବିବାହିତ',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Odia],
      identifier: 'maritalstatus',
    },
    {
      id: '742c1c17-52ef-400a-bd9e-5b2679fdb098',
      label: 'ରୂପ',
      value: 'ମଧ୍ୟମ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Odia],
      identifier: 'complexion',
    },
    {
      id: '50ef616c-317d-4ea5-a36a-6b82e9bc01e9',
      label: 'ଉଚ୍ଚତା',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: '2bf7b10a-daf6-4b32-a700-7b739fb111bc',
      label: 'ରକ୍ତ ଗୋଷ୍ଠୀ',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Odia],
      identifier: 'bloodgroup',
    },
    {
      id: '2d334f5d-b915-4b8c-8311-035e9556b2b5',
      label: 'ଜାତି',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ସୋନାର / ସୁନାର',
      identifier: 'caste',
    },
    {
      id: '14fbb8fd-bb19-4863-95e2-b0d147a0c360',
      label: 'ଗୋତ୍ର',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'କଶ୍ୟପ',
      identifier: 'gothra',
    },
    {
      id: '1f879d34-d28b-4c42-a949-f092d56657a2',
      label: 'ମୂଳ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'ଛତ୍ରପୁରୀ',
      identifier: 'mool',
    },
    {
      id: '443a0c4d-b879-489d-afba-8c9f58ca066a',
      label: 'ରାଶି',
      value: 'ମେଷ (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Odia],
      identifier: 'rashi',
    },
    {
      id: '1a90268e-2c74-4436-8439-426f15efa547',
      label: 'ନକ୍ଷତ୍ର',
      value: 'ଅଶ୍ୱିନୀ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'ଅଶ୍ୱିନୀ',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Odia],
      identifier: 'nakshatra',
    },
    {
      id: 'a4c87cfe-9671-4cb9-81b8-3fea28ab155b',
      label: 'ସଉଖ',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'ପସନ୍ଦ କରନ୍ତୁ କିମ୍ବା ଲେଖି ଏବଂ Enter ଦବାନ୍ତୁ',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Odia],
    },
    {
      id: '05749755-22b1-4ee2-b37e-abcc41ec67a9',
      label: 'ଶିକ୍ଷା',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'B.Com. (ବ୍ୟାପାରର ସ୍ନାତକ)',
      identifier: 'education',
    },
    {
      id: 'b9935f2c-c22c-4a09-be1f-6c4e184c843f',
      label: 'ପେଶା',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ମାନବ ସଂସାଧନ (HR)',
      identifier: 'occupation',
    },
    {
      id: '214b0f6d-5ffb-4e55-8bea-64d27d9847b6',
      label: 'କାମ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ଆଇସିଆଇସିଆଇ ବ୍ୟାଙ୍କ, ମୁମ୍ବାଇ',
      identifier: 'work',
    },
    {
      id: 'e90e0928-6326-4256-83db-9925adca2435',
      label: 'ଆୟ (ବାର୍ଷିକ)',
      value: '₹ 5 - 7.5 ଲକ୍ଷ',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Odia],
      identifier: 'income',
    },
  ],
  [SupportedLanguage.Malayalam]: [
    {
      id: '543e0e3a-7c19-4584-bf84-9dc3834811ac',
      label: 'പേര്',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'അങ്കിത് വർമ്മ',
      identifier: 'name',
    },
    {
      id: 'a4fcf903-90d5-422e-bf58-c40e0ac943f8',
      label: 'ജനന തീയതി',
      value: format(new Date(), 'dd MMMM yyyy'),
      type: FieldType.DATE,
      isHidden: false,
      isDefault: true,
      identifier: 'dateofbirth',
    },
    {
      id: 'b78047ee-a362-445a-bcb4-2d91079fcbd8',
      label: 'ജനന സമയം',
      value: format(new Date(), 'hh:mm a'),
      type: FieldType.TIME,
      isHidden: false,
      isDefault: true,
      identifier: 'timeofbirth',
    },
    {
      id: '1ae7e50f-12b2-458c-8c92-cbeff7e8cd27',
      label: 'ജനന സ്ഥലം',
      value: '',
      type: FieldType.TEXT_FIELD,
      placeholder: 'മുംബൈ',
      isHidden: false,
      isDefault: true,
      identifier: 'placeofbirth',
    },
    {
      id: 'e70f8dd9-19b8-4715-b763-e429ee6d7858',
      label: 'വൈവാഹിക സ്ഥിതി',
      value: 'ഒരിക്കലും വിവാഹിതരായിട്ടില്ല',
      type: FieldType.SELECT,
      placeholder: '',
      isHidden: true,
      isDefault: true,
      options: MARITALSTATUS_OPTIONS[SupportedLanguage.Malayalam],
      identifier: 'maritalstatus',
    },
    {
      id: '6a0190b0-1966-4816-bf09-d3b815a04707',
      label: 'ത്വക്ക് നിറം',
      value: 'ഇടത്തരം',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: COMPLEXION_OPTIONS[SupportedLanguage.Malayalam],
      identifier: 'complexion',
    },
    {
      id: '4d910ad6-e83d-474a-85b2-e7595eb31a9a',
      label: 'ഉയരം',
      value: '5\' 8"',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: HEIGHT_OPTIONS,
      identifier: 'height',
    },
    {
      id: '0f159dd2-88c4-4c1c-b883-eeb4b2ec63e1',
      label: 'രക്ത ഗ്രൂപ്പ്',
      value: 'AB+',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: BLOODGROUP_OPTIONS[SupportedLanguage.Malayalam],
      identifier: 'bloodgroup',
    },
    {
      id: '7ccdffdb-8858-4342-b8ea-3018327130c2',
      label: 'ജാതി',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'സോനാർ / സുനാർ',
      identifier: 'caste',
    },
    {
      id: 'a699276b-c701-4e10-99f1-efc6f61ca2a4',
      label: 'ഗോത്രം',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: true,
      isDefault: true,
      placeholder: 'കശ്യപ',
      identifier: 'gothra',
    },
    {
      id: '354d2d77-4716-4eed-af9f-ffe583cf19a0',
      label: 'മൂൾ',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: true,
      isDefault: true,
      placeholder: 'ചത്രപുരി',
      identifier: 'mool',
    },
    {
      id: '4ea3d7ae-67ea-46f8-90f4-d2875b107e88',
      label: 'രാശി',
      value: 'മേഷം (Aries)',
      type: FieldType.SELECT,
      isHidden: false,
      isDefault: true,
      options: RASHI_OPTIONS[SupportedLanguage.Malayalam],
      identifier: 'rashi',
    },
    {
      id: '3b011cd2-718a-4659-9d79-36fe9633be27',
      label: 'നക്ഷത്രം',
      value: 'അശ്വതി',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      placeholder: 'അശ്വതി',
      options: NAKSHATRA_OPTIONS[SupportedLanguage.Malayalam],
      identifier: 'nakshatra',
    },
    {
      id: '64a2d93d-172e-4d1f-9b91-80b043ed4e16',
      label: 'ഹോബികൾ',
      value: [],
      type: FieldType.MULTI_SELECT,
      isHidden: false,
      isDefault: true,
      placeholder: 'തിരഞ്ഞെടുക്കുക അല്ലെങ്കിൽ ടൈപ്പ് ചെയ്ത് Enter അമർത്തുക',
      identifier: 'hobbies',
      options: HOBBIES_OPTIONS[SupportedLanguage.Malayalam],
    },
    {
      id: '4f5998e4-a144-4d95-8058-3f298f887923',
      label: 'വിദ്യാഭ്യാസം',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'ബി.കോം. (വാണിജ്യത്തിൽ ബിരുദം)',
      identifier: 'education',
    },
    {
      id: '106a0f37-3464-430d-8d65-e19873bef8ba',
      label: 'തൊഴിൽ',
      value: '',
      type: FieldType.AUTOCOMPLETE,
      isHidden: false,
      isDefault: true,
      placeholder: 'മാനവ വിഭവശേഷി (HR)',
      identifier: 'occupation',
    },
    {
      id: '83ef90f1-43a9-427b-b8cf-52d9aacdd6c4',
      label: 'ജോലി സ്ഥലം',
      value: '',
      type: FieldType.TEXT_FIELD,
      isHidden: false,
      isDefault: true,
      placeholder: 'ഐസിഐസിഐ ബാങ്ക്, മുംബൈ',
      identifier: 'work',
    },
    {
      id: '1f88bef6-9723-49ed-8c75-163ee69254d1',
      label: 'വാർഷിക വരുമാനം',
      value: '₹ 5 - 7.5 ലക്ഷം',
      type: FieldType.SELECT,
      isHidden: true,
      isDefault: true,
      options: INCOME_OPTIONS[SupportedLanguage.Malayalam],
      identifier: 'income',
    },
  ],
}
